import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const iothub = props => {
    return (
        <div className={classes.TitleBox}>
            <img src="/assets/images/iotHubColorIcon.svg" alt="iot hub" />
            <p>{applicationTitles.iotHub}</p>
        </div>
    );
};

export default iothub;
